// import React, { useEffect, useState, useContext } from "react";
// import { useParams, useNavigate } from "react-router-dom";
// import {
//   Box,
//   Typography,
//   Card,
//   CardContent,
//   Divider,
//   CircularProgress,
//   IconButton,
//   Avatar,
//   TextField,
//   Button
// } from "@mui/material";
// import ArrowBackIosNewIcon from "@mui/icons-material/ArrowBackIosNew";
// import LinkIcon from "@mui/icons-material/Link";
// import axios from "axios";
// import { BASE_URL } from "../../Api/ApiUrls";
// import CustomBottomNavbar from "../../Users/Post Module/FormsBottomNavbar";
// import { AuthContext } from "../../AuthContext/AuthContext";
// import GuestLoginModal from '../../GuestLoginModal';
// import SuccessAlert from '../../../Components/Users/Alertpage/SuccessAlert/SuccessAlert';
// import FailureAlert from '../../../Components/Users/Alertpage/FailureAlert/FailureAlert';
// const RESPONSE_API_ENDPOINT = `${BASE_URL}/response-property-request/`;

// const WantedPropDetails = () => {
//   const { req_id } = useParams();
//   const navigate = useNavigate();
//   const { userId, isGuest } = useContext(AuthContext);
  
//   const [data, setData] = useState(null);
//   const [responses, setResponses] = useState([]);
//   const [loading, setLoading] = useState(true);
//   const [showSuccess, setShowSuccess] = useState(false);
//   const [showFailure, setShowFailure] = useState(false);
//   const [alertMessage, setAlertMessage] = useState("");
  
//   // Comments section state (for URL inputs)
//   const [openComments, setOpenComments] = useState(true);
//   const [showCommentInput, setShowCommentInput] = useState(false);
//   const [propertyLink, setPropertyLink] = useState("");
  
//   // Responses section state (for displaying data)
//   const [openResponses, setOpenResponses] = useState(true);
  
//   const [submitting, setSubmitting] = useState(false);
//   const [showGuestModal, setShowGuestModal] = useState(false);
//   const [usersMap, setUsersMap] = useState({});

//   const colors = {
//     primary: "#1a1a1a",
//     secondary: "#8B7355",
//     accent: "#A52A2A",
//     background: "#b9a990",
//     cardBackground: "#FFFFFF",
//     textDark: "#1a1a1a",
//     textLight: "#FFFFFF",
//     textMuted: "#666666"
//   };

//   // Fetch users for mapping
//   useEffect(() => {
//     fetch(`${BASE_URL}/users/`)
//       .then(res => res.json())
//       .then(data => {
//         const map = {};
//         data.forEach(user => {
//           map[user.user_id] = user.username;
//         });
//         setUsersMap(map);
//       })
//       .catch(err => console.error("Failed to fetch users", err));
//   }, []);

//   const requireLogin = (e, callback) => {
//     e.stopPropagation();
//     if (isGuest) {
//       setShowGuestModal(true);
//       return;
//     }
//     callback();
//   };

//   const formatPropertyId = (id) => {
//     return `WP${String(id).padStart(4, '0')}`;
//   };

//   const formatDate = (dateString) => {
//     const date = new Date(dateString);
//     const now = new Date();
//     const diffMs = now - date;
//     const diffDays = Math.floor(diffMs / (1000 * 60 * 60 * 24));
    
//     if (diffDays === 0) return "Today";
//     if (diffDays === 1) return "Yesterday";
//     if (diffDays < 7) return `${diffDays} days ago`;
//     if (diffDays < 30) return `${Math.floor(diffDays / 7)} weeks ago`;
//     return date.toLocaleDateString('en-IN', { day: 'numeric', month: 'short' });
//   };

//   const formatBudget = (min, max) => {
//     if (!min && !max) return "Not specified";

//     const formatNumber = (num) => {
//       const numValue = parseFloat(num) || 0;

//       if (numValue >= 10000000) {
//         return `₹${(numValue / 10000000).toFixed(1)} Cr`;
//       } else if (numValue >= 100000) {
//         return `₹${(numValue / 100000).toFixed(1)} L`;
//       } else if (numValue >= 1000) {
//         return `₹${(numValue / 1000).toFixed(1)} K`;
//       } else {
//         return `₹${numValue}`;
//       }
//     };

//     const minNum = parseFloat(min) || 0;
//     const maxNum = parseFloat(max) || 0;

//     if (minNum === maxNum) return formatNumber(minNum);

//     const minFormatted = formatNumber(minNum);
//     const maxFormatted = formatNumber(maxNum);

//     const getSuffix = (str) => {
//       if (str.includes('Cr')) return 'Cr';
//       if (str.includes('L')) return 'L';
//       if (str.includes('K')) return 'K';
//       return '';
//     };

//     const minSuffix = getSuffix(minFormatted);
//     const maxSuffix = getSuffix(maxFormatted);

//     if (minSuffix && minSuffix === maxSuffix) {
//       const minValue = minFormatted.replace(` ${minSuffix}`, '').replace('₹', '');
//       const maxValue = maxFormatted.replace(` ${maxSuffix}`, '').replace('₹', '');
//       return `₹${minValue}-${maxValue} ${minSuffix}`;
//     }

//     return `${minFormatted} - ${maxFormatted}`;
//   };

//  const getValidLinkPatterns = () => {
//   const lookingFor = data?.looking_for?.toLowerCase() || '';

//   const basePatterns = {
//     purchase: [
//       /^https?:\/\/test\.propertypincoder\.com\/buy-description\/\d+$/,
//       /^https?:\/\/localhost:3000\/buy-description\/\d+$/,
//       /^https?:\/\/app\.propertypincoder\.com\/buy-description\/\d+$/,
//       /^https?:\/\/app\.propertypincoder\.com\/hot-property-description\/\d+$/
//     ],

//     rent: [
//       /^https?:\/\/test\.propertypincoder\.com\/rent-description\/\d+$/,
//       /^https?:\/\/localhost:3000\/rent-description\/\d+$/,
//       /^https?:\/\/app\.propertypincoder\.com\/rent-description\/\d+$/
//     ],

//     lease: [
//       /^https?:\/\/test\.propertypincoder\.com\/lease-description\/\d+$/,
//       /^https?:\/\/localhost:3000\/lease-description\/\d+$/,
//       /^https?:\/\/app\.propertypincoder\.com\/lease-description\/\d+$/
//     ]
//   };

//   if (lookingFor.includes('purchase')) return basePatterns.purchase;
//   if (lookingFor.includes('rent')) return basePatterns.rent;
//   if (lookingFor.includes('lease')) return basePatterns.lease;

//   return [
//     /^https?:\/\/test\.propertypincoder\.com\/.+\/\d+$/,
//     /^https?:\/\/localhost:3000\/.+\/\d+$/,
//     /^https?:\/\/app\.propertypincoder\.com\/.+\/\d+$/
//   ];
// };

// const isValidPropertyLink = (link) =>
//   getValidLinkPatterns().some((pattern) => pattern.test(link));

// const handleSubmitUrl = async () => {
//   if (!propertyLink.trim()) {
//     setAlertMessage("Please enter a property link");
//     setShowFailure(true);
//     return;
//   }

//   if (!isValidPropertyLink(propertyLink.trim())) {
//     const lookingFor = data?.looking_for?.toLowerCase() || '';

//     const examples = {
//       purchase:
//         "https://test.propertypincoder.com/buy-description/162 or http://localhost:3000/buy-description/59",

//       rent:
//         "https://test.propertypincoder.com/rent-description/162 or http://localhost:3000/rent-description/59",

//       lease:
//         "https://test.propertypincoder.com/lease-description/162 or http://localhost:3000/lease-description/59",
//     };

//     let validExample =
//       examples[lookingFor.includes("purchase")
//         ? "purchase"
//         : lookingFor.includes("rent")
//         ? "rent"
//         : lookingFor.includes("lease")
//         ? "lease"
//         : "purchase"];

//     setAlertMessage(
//       `Invalid property link.\n\nValid examples:\n${validExample}`
//     );
//     setShowFailure(true);
//     return;
//   }

//   setSubmitting(true);

//   try {
//     const response = await fetch(RESPONSE_API_ENDPOINT, {
//       method: "POST",
//       headers: {
//         "Content-Type": "application/json",
//       },
//       body: JSON.stringify({
//         comment: "",
//         proerty_link: propertyLink,
//         req_id: parseInt(req_id),
//         user_id: userId,
//       }),
//     });

//     if (response.ok) {
//       const newResponse = await response.json();

//       setResponses((prev) => [newResponse, ...prev]);
//       setPropertyLink("");
//       setShowCommentInput(false);

//       setAlertMessage("Property link submitted successfully!");
//       setShowSuccess(true);
//     } else {
//       throw new Error("Failed to submit");
//     }
//   } catch (err) {
//     console.error("Error submitting:", err);
//     setAlertMessage("Failed to submit. Please try again.");
//     setShowFailure(true);
//   } finally {
//     setSubmitting(false);
//   }
// };

//   useEffect(() => {
//     const fetchDetails = async () => {
//       try {
//         const [propertyRes, responsesRes] = await Promise.all([
//           axios.get(`${BASE_URL}/property-request/${req_id}/`),
//           axios.get(`${BASE_URL}/response-property-request/`)
//         ]);
        
//         setData(propertyRes.data);
        
//         // Filter responses for this specific property request
//         const propertyResponses = responsesRes.data
//           .filter(response => response.req_id == req_id)
//           .reverse();
        
//         setResponses(propertyResponses);
//       } catch (err) {
//         console.error("Failed to fetch data:", err);
//       } finally {
//         setLoading(false);
//       }
//     };

//     fetchDetails();
//   }, [req_id]);

//   const toggleComments = () => {
//     setOpenComments(prev => !prev);
//   };

//   const toggleResponses = () => {
//     setOpenResponses(prev => !prev);
//   };

//   const handleViewAllResponses = () => {
//     navigate("/all-responses", {
//       state: {
//         responses: responses,
//         property: data
//       }
//     });
//   };

//   // Filter responses that have links
//   const responseItems = responses.filter(r => r.proerty_link);

//   // Render response item for display
//   const renderResponseItem = (response, index) => (
//     <Box
//       key={index}
//       sx={{
//         mb: 1,
//         p: 1,
//         backgroundColor: 'white',
//         borderRadius: 0.5,
//         boxShadow: '0 1px 3px rgba(0,0,0,0.1)',
//         border: '1px solid #e0e0e0'
//       }}
//     >
//       <Box sx={{ display: 'flex', alignItems: 'center', mb: 0.5 }}>
//         <Avatar
//           sx={{
//             width: 20,
//             height: 20,
//             mr: 0.75,
//             bgcolor: colors.secondary,
//             fontSize: '0.6rem',
//             color: colors.textLight
//           }}
//         >
//           {usersMap[response.user_id]?.charAt(0)?.toUpperCase() || 'U'}
//         </Avatar>

//         <Box sx={{ display: 'flex', justifyContent: 'space-between', width: '100%' }}>
//           <Typography
//             variant="caption"
//             fontWeight="bold"
//             color={colors.primary}
//             sx={{ fontSize: '0.65rem' }}
//           >
//             {usersMap[response.user_id] || `User ${response.user_id}`}
//           </Typography>

//           <Typography
//             variant="caption"
//             color={colors.textMuted}
//             sx={{ fontSize: '0.6rem' }}
//           >
//             {formatDate(response.created_at || new Date())}
//           </Typography>
//         </Box>
//       </Box>
      
//       {/* Show property link */}
//       {response.proerty_link && (
//         <Box sx={{ mt: 0.5 }}>
//           <Typography 
//             component="a" 
//             href={response.proerty_link} 
//             target="_blank" 
//             rel="noopener noreferrer"
//             sx={{ 
//               color: '#1976d2', 
//               textDecoration: 'underline', 
//               fontSize: '0.65rem',
//               display: 'flex',
//               alignItems: 'center',
//               gap: 0.5,
//               '&:hover': { 
//                 color: '#1565c0', 
//                 textDecoration: 'underline' 
//               } 
//             }}
//           >
//             <LinkIcon sx={{ fontSize: '0.7rem' }} />
//             View Property
//           </Typography>
//         </Box>
//       )}
//     </Box>
//   );

//   if (loading) {
//     return (
//       <Box sx={{ 
//         minHeight: "100vh", 
//         display: "flex", 
//         justifyContent: "center", 
//         alignItems: "center",
//         backgroundColor: 'rgb(239, 231, 221)'
//       }}>
//         <CircularProgress size={40} thickness={5} sx={{ color: '#000000' }} />
//       </Box>
//     );
//   }

//   if (!data) {
//     return (
//       <Box sx={{ 
//         minHeight: "100vh", 
//         display: "flex", 
//         justifyContent: "center", 
//         alignItems: "center",
//         backgroundColor: colors.background
//       }}>
//         <Typography textAlign="center">No data found</Typography>
//       </Box>
//     );
//   }

// return (
//   <Box sx={{ display: "flex", flexDirection: "column", height: "100vh", backgroundColor: "#d8ccba" }}>
//     {/* Fixed Header */}
//     <Box
//       sx={{
//         backgroundColor: "#000",
//         color: "#fff",
//         px: 2,
//         py: 1,
//         display: "flex",
//         alignItems: "center",
//         position: "fixed",
//         top: 0,
//         left: 0,
//         right: 0,
//         zIndex: 1200,
//       }}
//     >
//       <IconButton sx={{ color: "#fff" }} onClick={() => navigate(-1)}>
//         <ArrowBackIosNewIcon fontSize="small" />
//       </IconButton>

//       <Typography fontWeight={600} flexGrow={1}>
//         Property Request Details
//       </Typography>

//       <Box textAlign="right">
//         <Typography variant="caption">
//           ID: {formatPropertyId(data.req_id)}
//         </Typography>
//         <Typography variant="caption" display="block">
//           {new Date(data.created_at).toLocaleDateString()}
//         </Typography>
//       </Box>
//     </Box>

//     {/* Scrollable Content */}
//     <Box sx={{ 
//       flex: 1, 
//       overflowY: "auto",
//       mt: "56px", // Height of fixed header
//       mb: "56px", // Height of bottom navbar
//       px: 2,
//       py: 2
//     }}>
//       <Card sx={{ borderRadius: 2 }}>
//         <CardContent>
//           {/* Header Section */}
//           <Box sx={{ 
//             display: 'flex', 
//             alignItems: 'center', 
//             justifyContent: 'space-between',
//             mb: 2,
//             p: 1,
//             backgroundColor: colors.primary,
//             borderRadius: 1,
//             color: colors.textLight
//           }}>
//             <Box sx={{ 
//               backgroundColor: "#b9a990", 
//               color: colors.primary,
//               px: 1.5,
//               py: 0.5,
//               borderRadius: 3,
//               display: 'flex',
//               alignItems: 'center',
//               justifyContent: 'center'
//             }}>
//               <Typography variant="body2" fontWeight="bold">
//                 {data.looking_for ? data.looking_for.charAt(0).toUpperCase() + data.looking_for.slice(1) : "Property"}
//               </Typography>
//             </Box>
            
//             <Box sx={{ 
//               backgroundColor: colors.cardBackground, 
//               color: colors.primary,
//               px: 1.5,
//               py: 0.5,
//               borderRadius: 3,
//               display: 'flex',
//               alignItems: 'center',
//               justifyContent: 'center'
//             }}>
//               <Typography variant="body2" fontWeight="bold">
//                 Budget: {formatBudget(data.min_budget, data.max_budget)}
//               </Typography>
//             </Box>
//           </Box>

//           <Detail label="Property Type" value={data.property_type || "Not specified"} />
//           <Divider sx={{ my: 1 }} />

//           {/* Budget Section */}
//           <Typography variant="subtitle1" fontWeight={700} sx={{ mt: 1, color: colors.accent }}>
//             Budget Details
//           </Typography>
          
//           {data.looking_for === "rent" ? (
//             <>
//               <Detail label="Monthly Rent Range" value={`₹${data.min_monthly_rent} - ₹${data.max_monthly_rent}`} />
//               <Detail label="Lease Period" value={`${data.min_year_lease} - ${data.max_year_lease} years`} />
//             </>
//           ) : (
//             <>
//               <Detail label="Budget Range" value={`₹${data.min_budget} - ₹${data.max_budget}`} />
              
//               {(data.min_budget_per_acre || data.max_budget_per_acre) && (
//                 <Detail 
//                   label="Budget Per Acre" 
//                   value={`₹${data.min_budget_per_acre || 0} - ₹${data.max_budget_per_acre || 0}`} 
//                 />
//               )}
//             </>
//           )}

//           {(data.min_expected_rental_income || data.max_expected_rental_income) && (
//             <Detail 
//               label="Expected Rental Income" 
//               value={`₹${data.min_expected_rental_income || 0} - ₹${data.max_expected_rental_income || 0}`} 
//             />
//           )}

//           <Divider sx={{ my: 1 }} />

//           {/* Property Specifications */}
//           <Typography variant="subtitle1" fontWeight={700} sx={{ mt: 1, color: colors.accent }}>
//             Property Specifications
//           </Typography>

//           {(data.length > 0 && data.width > 0) && (
//             <Detail label="Dimensions" value={`${data.length} x ${data.width} ${data.units}`} />
//           )}

//           {data.area > 0 && (
//             <Detail label="Area" value={`${data.area} ${data.units}²`} />
//           )}

//           {(data.min_acres > 0 || data.max_acres > 0) && (
//             <Detail
//               label="Land Size (Acres)"
//               value={`${data.min_acres}${data.max_acres > data.min_acres ? ` - ${data.max_acres}` : ""} acres`}
//             />
//           )}

//           {data.ratio && <Detail label="Ratio" value={data.ratio} />}
//           {data.floor > 0 && <Detail label="Floor" value={data.floor} />}
//           {data.no_of_bedrooms > 0 && <Detail label="Bedrooms" value={data.no_of_bedrooms} />}

//           <Divider sx={{ my: 1 }} />

//           {/* Locations */}
//           {data.pro_loc && data.pro_loc.length > 0 && (
//             <>
//               <Typography variant="subtitle1" fontWeight={700} sx={{ mt: 1, color: colors.accent }}>
//                 Preferred Locations
//               </Typography>
//               {data.pro_loc.map((loc, idx) => (
//                 <Typography key={idx} sx={{ fontSize: "0.85rem", mt: 0.5, color: colors.textMuted }}>
//                   📍 {loc.location}
//                 </Typography>
//               ))}
//               <Divider sx={{ my: 1 }} />
//             </>
//           )}

//           {/* User and Timestamp Info */}
//           <Typography variant="subtitle1" fontWeight={700} sx={{ mt: 1, color: colors.accent }}>
//             Request Information
//           </Typography>
          
//           <Detail label="Last Updated" value={new Date(data.updated_at).toLocaleString()} />

//      {data.comment && (
//   <>
//     <Divider sx={{ my: 1 }} />

//     {/* Header */}
// <Typography
//   variant="subtitle1"
//   fontWeight={700}
//   sx={{ color: colors.accent, mb: 0.5 }} 
// >
//   Comments
// </Typography>

// {/* Comment text - without p tag */}
// <Typography
//   sx={{
//     fontSize: "0.85rem",
//     color: colors.textMuted,
//     lineHeight: 1.2 
//   }}
// >
//   Please paste url if you have related property in app
// </Typography>

//     {/* URL INPUT FIELD - Always Visible */}
//     <Box
//       sx={{
//         mb: 2,
//         mt: 2,
//         p: 1.5,
//         backgroundColor: "#f5f2ee",
//         borderRadius: 1
//       }}
//     >
//       <TextField
//         fullWidth
//         variant="outlined"
//         placeholder="Paste property link"
//         value={propertyLink}
//         onChange={(e) => setPropertyLink(e.target.value)}
//         size="small"
//         sx={{ mb: 1 }}
//         InputProps={{
//           sx: {
//             fontSize: "0.75rem",
//             backgroundColor: "white"
//           }
//         }}
//       />

//       <Box sx={{ display: "flex", justifyContent: "flex-end", gap: 0.5 }}>
//           {/* <Button
//           size="small"
//           onClick={() => setPropertyLink("")}
//           sx={{
//             color: colors.secondary,
//             fontSize: "0.65rem",
//             minWidth: "auto",
//             px: 1
//           }}
//         >
//           Cancel
//         </Button> */}
//         <Button
//           variant="contained"
//           size="small"
//           onClick={handleSubmitUrl}
//           disabled={submitting || !propertyLink.trim()}
//           sx={{
//             fontSize: "0.65rem",
//             minWidth: "auto",
//             px: 1,
//             backgroundColor: propertyLink.trim()
//               ? colors.accent
//               : "#ccc",
//             color: colors.textLight,
//             "&:hover": {
//               backgroundColor: colors.accent
//             }
//           }}
//         >
//           {submitting ? "..." : "Submit"}
//         </Button>
//       </Box>
//     </Box>
//   </>
// )}

//           {/* ================= RESPONSES SECTION - DATA DISPLAY ================= */}
//           <Box sx={{ mt: 3, pt: 2, borderTop: '1px dashed #ccc' }}>
//             <Box sx={{ 
//               display: 'flex', 
//               alignItems: 'center', 
//               justifyContent: 'space-between',
//               mb: 1
//             }}>
//               <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
//                 <Typography
//                   variant="subtitle1"
//                   fontWeight={700}
//                   sx={{ color: colors.accent }}
//                 >
//                   Property Responses ({responseItems.length})
//                 </Typography>
//               </Box>
              
//               <Typography
//                 onClick={toggleResponses}
//                 sx={{
//                   fontSize: '0.75rem',
//                   fontWeight: 600,
//                   cursor: 'pointer',
//                   color: '#a89478ff'
//                 }}
//               >
//                 {openResponses ? 'Hide' : 'Show'}
//               </Typography>
//             </Box>

//             {/* RESPONSES DATA DISPLAY */}
//             {openResponses && (
//               <Box>
//                 {responseItems.length === 0 ? (
//                   <Typography sx={{ fontSize: "0.85rem", color: colors.textMuted, textAlign: "center", py: 2 }}>
//                     No property responses yet.
//                   </Typography>
//                 ) : (
//                   <>
//                     {/* Show first 2 responses */}
//                     {responseItems.slice(0, 2).map((response, index) => (
//                       renderResponseItem(response, index)
//                     ))}

//                     {/* View All Link if more than 2 responses */}
//                     {responseItems.length > 2 && (
//                       <Box sx={{ textAlign: 'center', mt: 1 }}>
//                         <Typography
//                           onClick={handleViewAllResponses}
//                           sx={{
//                             fontSize: '0.8rem',
//                             fontWeight: 600,
//                             cursor: 'pointer',
//                             color: colors.secondary,
//                             '&:hover': {
//                               textDecoration: 'underline'
//                             }
//                           }}
//                         >
//                           View all {responseItems.length} responses →
//                         </Typography>
//                       </Box>
//                     )}
//                   </>
//                 )}
//               </Box>
//             )}
//           </Box>
//         </CardContent>
//       </Card>
//     </Box>

//     {/* Guest Login Modal */}
//     <GuestLoginModal
//       open={showGuestModal}
//       onClose={() => setShowGuestModal(false)}
//     />

//     {/* Success Alert */}
//     {showSuccess && (
//       <SuccessAlert
//         message={alertMessage}
//         onClose={() => {
//           setShowSuccess(false);
//           setAlertMessage("");
//         }}
//       />
//     )}
    
//     {/* Failure Alert */}
//     {showFailure && (
//       <FailureAlert
//         message={alertMessage}
//         onClose={() => {
//           console.log("Closing failure alert");
//           setShowFailure(false);
//           setAlertMessage(""); 
//         }}
//       />
//     )}

//     {/* Fixed Bottom Navigation */}
//     <Box
//       sx={{
//         position: "fixed",
//         bottom: 0,
//         left: 0,
//         right: 0,
//         zIndex: 1300,
//       }}
//     >
//       <CustomBottomNavbar />
//     </Box>
//   </Box>
// );
// };

// /* Reusable Row */
// const Detail = ({ label, value }) => (
//   <Box sx={{ display: "flex", justifyContent: "space-between", my: 0.8 }}>
//     <Typography fontWeight={600} fontSize="0.85rem">
//       {label}
//     </Typography>
//     <Typography fontSize="0.85rem" color="text.secondary">
//       {value || "—"}
//     </Typography>
//   </Box>
// );

// export default WantedPropDetails;


import React, { useEffect, useState, useContext } from "react";
import { useParams, useNavigate } from "react-router-dom";
import {
  Box,
  Typography,
  Card,
  Divider,
  CircularProgress,
  IconButton,
  Avatar,
  TextField,
  Button,
} from "@mui/material";
import ArrowBackIosNewIcon from "@mui/icons-material/ArrowBackIosNew";
import LinkIcon from "@mui/icons-material/Link";
import CurrencyRupeeIcon from "@mui/icons-material/CurrencyRupee";
import HomeWorkOutlinedIcon from "@mui/icons-material/HomeWorkOutlined";
import StraightenOutlinedIcon from "@mui/icons-material/StraightenOutlined";
import LocationOnIcon from "@mui/icons-material/LocationOn";
import CalendarMonthOutlinedIcon from "@mui/icons-material/CalendarMonthOutlined";
import PersonOutlineIcon from "@mui/icons-material/PersonOutline";
import ChatBubbleOutlineIcon from "@mui/icons-material/ChatBubbleOutline";
import DescriptionOutlinedIcon from "@mui/icons-material/DescriptionOutlined";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import StarIcon from "@mui/icons-material/Star";
import KeyboardArrowRightIcon from "@mui/icons-material/KeyboardArrowRight";
import StorefrontIcon from "@mui/icons-material/Storefront";
import ApartmentIcon from "@mui/icons-material/Apartment";
import CropSquareIcon from "@mui/icons-material/CropSquare";
import VerifiedIcon from "@mui/icons-material/Verified";
import PeopleAltIcon from "@mui/icons-material/PeopleAlt";
import KeyboardArrowUpIcon from "@mui/icons-material/KeyboardArrowUp";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import axios from "axios";
import { BASE_URL } from "../../Api/ApiUrls";
import CustomBottomNavbar from "../../Users/Post Module/FormsBottomNavbar";
import { AuthContext } from "../../AuthContext/AuthContext";
import GuestLoginModal from "../../GuestLoginModal";
import SuccessAlert from "../../../Components/Users/Alertpage/SuccessAlert/SuccessAlert";
import FailureAlert from "../../../Components/Users/Alertpage/FailureAlert/FailureAlert";

const RESPONSE_API_ENDPOINT = `${BASE_URL}/response-property-request/`;

// ─── palette (matched to screenshot) ────────────────────────────────────────
const C = {
  pageBg: "#F5EFE6",
  cardBg: "#FFFFFF",
  brown: "#6B4A2B",        // dark brown header / accents
  brownLight: "#8B6B4A",
  brownFaded: "#A8886B",
  tan: "#F2E9DC",          // pill background
  tanBorder: "#E5D5C0",
  green: "#4CAF50",
  greenBg: "#E8F5E9",
  star: "#F5A623",
  textDark: "#2B1D12",
  textMid: "#5C4A38",
  textMuted: "#8A7A68",
  divider: "#E5D5C0",
};

const WantedPropDetails = () => {
  const { req_id } = useParams();
  const navigate = useNavigate();
  const { userId, isGuest } = useContext(AuthContext);

  const [data, setData] = useState(null);
  const [responses, setResponses] = useState([]);
  const [loading, setLoading] = useState(true);
  const [showSuccess, setShowSuccess] = useState(false);
  const [showFailure, setShowFailure] = useState(false);
  const [alertMessage, setAlertMessage] = useState("");

  const [openComments, setOpenComments] = useState(true);
  const [propertyLink, setPropertyLink] = useState("");

  const [openResponses, setOpenResponses] = useState(true);
  const [submitting, setSubmitting] = useState(false);
  const [showGuestModal, setShowGuestModal] = useState(false);
  const [usersMap, setUsersMap] = useState({});

  // ── fetch users ────────────────────────────────────────────────────────────
  useEffect(() => {
    fetch(`${BASE_URL}/users/`)
      .then((res) => res.json())
      .then((data) => {
        const map = {};
        data.forEach((user) => {
          map[user.user_id] = user.username;
        });
        setUsersMap(map);
      })
      .catch((err) => console.error("Failed to fetch users", err));
  }, []);

  const requireLogin = (e, callback) => {
    e.stopPropagation();
    if (isGuest) {
      setShowGuestModal(true);
      return;
    }
    callback();
  };

  const formatPropertyId = (id) => `WP${String(id).padStart(4, "0")}`;

  const formatDate = (dateString) => {
    if (!dateString) return "—";
    const date = new Date(dateString);
    return date.toLocaleDateString("en-IN", {
      day: "numeric",
      month: "short",
      year: "numeric",
    });
  };

  // ── format price ──────────────────────────────────────────────────────────
  const formatPrice = (num) => {
    const n = parseFloat(num) || 0;
    if (n >= 10000000) return `${(n / 10000000).toFixed(1).replace(/\.0$/, "")} Cr`;
    if (n >= 100000) return `${(n / 100000).toFixed(1).replace(/\.0$/, "")} L`;
    if (n >= 1000) return `${(n / 1000).toFixed(1).replace(/\.0$/, "")} K`;
    return `${n}`;
  };

  const formatBudget = (min, max) => {
    if (!min && !max) return "Not specified";
    const minNum = parseFloat(min) || 0;
    const maxNum = parseFloat(max) || 0;
    if (minNum === maxNum) return `₹${formatPrice(minNum)}`;
    return `₹${formatPrice(minNum)},000 - ₹${formatPrice(maxNum)},000`;
  };

  // ── handle submit URL ────────────────────────────────────────────────────
  const getValidLinkPatterns = () => {
    const lookingFor = data?.looking_for?.toLowerCase() || "";
    const basePatterns = {
      purchase: [
        /^https?:\/\/test\.propertypincoder\.com\/buy-description\/\d+$/,
        /^https?:\/\/localhost:3000\/buy-description\/\d+$/,
        /^https?:\/\/app\.propertypincoder\.com\/buy-description\/\d+$/,
        /^https?:\/\/app\.propertypincoder\.com\/hot-property-description\/\d+$/,
      ],
      rent: [
        /^https?:\/\/test\.propertypincoder\.com\/rent-description\/\d+$/,
        /^https?:\/\/localhost:3000\/rent-description\/\d+$/,
        /^https?:\/\/app\.propertypincoder\.com\/rent-description\/\d+$/,
      ],
      lease: [
        /^https?:\/\/test\.propertypincoder\.com\/lease-description\/\d+$/,
        /^https?:\/\/localhost:3000\/lease-description\/\d+$/,
        /^https?:\/\/app\.propertypincoder\.com\/lease-description\/\d+$/,
      ],
    };
    if (lookingFor.includes("purchase")) return basePatterns.purchase;
    if (lookingFor.includes("rent")) return basePatterns.rent;
    if (lookingFor.includes("lease")) return basePatterns.lease;
    return [
      /^https?:\/\/test\.propertypincoder\.com\/.+\/\d+$/,
      /^https?:\/\/localhost:3000\/.+\/\d+$/,
      /^https?:\/\/app\.propertypincoder\.com\/.+\/\d+$/,
    ];
  };

  const isValidPropertyLink = (link) =>
    getValidLinkPatterns().some((pattern) => pattern.test(link));

  const handleSubmitUrl = async () => {
    if (!propertyLink.trim()) {
      setAlertMessage("Please enter a property link");
      setShowFailure(true);
      return;
    }

    if (!isValidPropertyLink(propertyLink.trim())) {
      const lookingFor = data?.looking_for?.toLowerCase() || "";
      const examples = {
        purchase:
          "https://test.propertypincoder.com/buy-description/162 or http://localhost:3000/buy-description/59",
        rent:
          "https://test.propertypincoder.com/rent-description/162 or http://localhost:3000/rent-description/59",
        lease:
          "https://test.propertypincoder.com/lease-description/162 or http://localhost:3000/lease-description/59",
      };
      const validExample =
        examples[
          lookingFor.includes("purchase")
            ? "purchase"
            : lookingFor.includes("rent")
            ? "rent"
            : lookingFor.includes("lease")
            ? "lease"
            : "purchase"
        ];
      setAlertMessage(`Invalid property link.\n\nValid examples:\n${validExample}`);
      setShowFailure(true);
      return;
    }

    setSubmitting(true);
    try {
      const response = await fetch(RESPONSE_API_ENDPOINT, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          comment: "",
          proerty_link: propertyLink,
          req_id: parseInt(req_id),
          user_id: userId,
        }),
      });

      if (response.ok) {
        const newResponse = await response.json();
        setResponses((prev) => [newResponse, ...prev]);
        setPropertyLink("");
        setAlertMessage("Property link submitted successfully!");
        setShowSuccess(true);
      } else {
        throw new Error("Failed to submit");
      }
    } catch (err) {
      console.error("Error submitting:", err);
      setAlertMessage("Failed to submit. Please try again.");
      setShowFailure(true);
    } finally {
      setSubmitting(false);
    }
  };

  // ── fetch details ────────────────────────────────────────────────────────
  useEffect(() => {
    const fetchDetails = async () => {
      try {
        const [propertyRes, responsesRes] = await Promise.all([
          axios.get(`${BASE_URL}/property-request/${req_id}/`),
          axios.get(`${BASE_URL}/response-property-request/`),
        ]);
        setData(propertyRes.data);
        const propertyResponses = responsesRes.data
          .filter((response) => response.req_id == req_id)
          .reverse();
        setResponses(propertyResponses);
      } catch (err) {
        console.error("Failed to fetch data:", err);
      } finally {
        setLoading(false);
      }
    };
    fetchDetails();
  }, [req_id]);

  const toggleComments = () => setOpenComments((prev) => !prev);
  const toggleResponses = () => setOpenResponses((prev) => !prev);

  const handleViewAllResponses = () => {
    navigate("/all-responses", {
      state: { responses: responses, property: data },
    });
  };

  const responseItems = responses.filter((r) => r.proerty_link);

  // ── LOADING / EMPTY ────────────────────────────────────────────────────────
  if (loading) {
    return (
      <Box
        sx={{
          minHeight: "100vh",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          backgroundColor: C.pageBg,
        }}
      >
        <CircularProgress size={40} thickness={5} sx={{ color: C.brown }} />
      </Box>
    );
  }

  if (!data) {
    return (
      <Box
        sx={{
          minHeight: "100vh",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          backgroundColor: C.pageBg,
        }}
      >
        <Typography textAlign="center">No data found</Typography>
      </Box>
    );
  }

  // ── prepared display values ────────────────────────────────────────────────
  const lookingForLabel = data.looking_for
    ? data.looking_for.charAt(0).toUpperCase() + data.looking_for.slice(1)
    : "Property";

  const propertyTypeLabel = data.property_type || "Plot";
  const dimensionsLabel =
    data.length > 0 && data.width > 0
      ? `${data.length} x ${data.width} ${data.units || "ft"}`
      : "—";

  const budgetDisplay =
    data.min_budget && data.max_budget
      ? `₹${Number(data.min_budget).toLocaleString("en-IN")} - ₹${Number(
          data.max_budget
        ).toLocaleString("en-IN")}`
      : "Not specified";

  const locationsList = (data.pro_loc || []).map((l) => l.location);

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        minHeight: "100vh",
        backgroundColor: C.pageBg,
      }}
    >
      {/* ─────────── Fixed Header ─────────── */}
      <Box
        sx={{
          backgroundColor: C.brown,
          color: "#fff",
          px: 1.5,
          py: 1,
          display: "flex",
          alignItems: "center",
          position: "fixed",
          top: 0,
          left: 0,
          right: 0,
          zIndex: 1200,
          boxShadow: "0 2px 6px rgba(0,0,0,0.15)",
        }}
      >
        <IconButton sx={{ color: "#fff", p: 0.5 }} onClick={() => navigate(-1)}>
          <ArrowBackIosNewIcon sx={{ fontSize: 18 }} />
        </IconButton>
        <Typography fontWeight={600} fontSize="0.95rem" flexGrow={1} ml={0.5}>
          Property Request Details
        </Typography>
      </Box>

      {/* ─────────── Scrollable Content ─────────── */}
      <Box
        sx={{
          flex: 1,
          overflowY: "auto",
          mt: "48px",
          mb: "70px",
          px: 1.5,
          py: 1.5,
        }}
      >
        {/* ═══════════ TOP CARD — PROPERTY REQUEST ═══════════ */}
        <Card
          sx={{
            borderRadius: 3,
            backgroundColor: C.cardBg,
            boxShadow: "0 2px 10px rgba(107,74,43,0.08)",
            mb: 2,
          }}
        >
          <Box sx={{ p: 2 }}>
            {/* Header row */}
            <Box
              sx={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                mb: 2,
              }}
            >
              <Box
                sx={{
                  backgroundColor: C.brown,
                  color: "#fff",
                  px: 1.5,
                  py: 0.6,
                  borderRadius: "20px",
                  display: "flex",
                  alignItems: "center",
                  gap: 0.6,
                }}
              >
                <DescriptionOutlinedIcon sx={{ fontSize: 15 }} />
                <Typography fontSize="0.78rem" fontWeight={600}>
                  Property Request
                </Typography>
              </Box>

              <Box
                sx={{
                  backgroundColor: C.greenBg,
                  color: C.green,
                  px: 1.2,
                  py: 0.4,
                  borderRadius: "20px",
                  display: "flex",
                  alignItems: "center",
                  gap: 0.4,
                  border: `1px solid ${C.green}33`,
                }}
              >
                <Box
                  sx={{
                    width: 7,
                    height: 7,
                    borderRadius: "50%",
                    backgroundColor: C.green,
                  }}
                />
                <Typography fontSize="0.7rem" fontWeight={700}>
                  Open
                </Typography>
              </Box>
            </Box>

            {/* Budget / Type / Dimensions - 3 column */}
            <Box
              sx={{
                display: "grid",
                // gridTemplateColumns: "1.3fr 1fr 1fr",
                gap: 1.5,
                mb: 2,
              }}
            >
              {/* Budget */}
              <Box>
                <Box sx={{ display: "flex", alignItems: "center", gap: 0.5, mb: 0.4 }}>
                  <Box
                    sx={{
                      width: 26,
                      height: 26,
                      borderRadius: "50%",
                      backgroundColor: C.tan,
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                    }}
                  >
                    <CurrencyRupeeIcon sx={{ fontSize: 15, color: C.brown }} />
                  </Box>
                  <Typography fontSize="0.65rem" color={C.textMuted} fontWeight={600}>
                    Budget Range
                  </Typography>
                </Box>
                <Typography fontSize="0.72rem" fontWeight={700} color={C.textDark}>
                  {budgetDisplay}
                </Typography>
              </Box>

              {/* Property Type */}
              <Box>
                <Box sx={{ display: "flex", alignItems: "center", gap: 0.5, mb: 0.4 }}>
                  <Box
                    sx={{
                      width: 26,
                      height: 26,
                      borderRadius: "50%",
                      backgroundColor: C.tan,
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                    }}
                  >
                    <HomeWorkOutlinedIcon sx={{ fontSize: 15, color: C.brown }} />
                  </Box>
                  <Typography fontSize="0.65rem" color={C.textMuted} fontWeight={600}>
                    Property Type
                  </Typography>
                </Box>
                <Typography fontSize="0.82rem" fontWeight={700} color={C.textDark}>
                  {propertyTypeLabel}
                </Typography>
              </Box>

              {/* Dimensions */}
              <Box>
                <Box sx={{ display: "flex", alignItems: "center", gap: 0.5, mb: 0.4 }}>
                  <Box
                    sx={{
                      width: 26,
                      height: 26,
                      borderRadius: "50%",
                      backgroundColor: C.tan,
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                    }}
                  >
                    <StraightenOutlinedIcon sx={{ fontSize: 15, color: C.brown }} />
                  </Box>
                  <Typography fontSize="0.65rem" color={C.textMuted} fontWeight={600}>
                    Dimensions
                  </Typography>
                </Box>
                <Typography fontSize="0.82rem" fontWeight={700} color={C.textDark}>
                  {dimensionsLabel}
                </Typography>
              </Box>
            </Box>

            {/* Preferred Locations */}
            {locationsList.length > 0 && (
              <Box sx={{ mb: 2 }}>
                <Box sx={{ display: "flex", alignItems: "center", gap: 0.5, mb: 0.8 }}>
                  <Box
                    sx={{
                      width: 26,
                      height: 26,
                      borderRadius: "50%",
                      backgroundColor: C.tan,
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                    }}
                  >
                    <LocationOnIcon sx={{ fontSize: 15, color: C.brown }} />
                  </Box>
                  <Typography fontSize="0.78rem" fontWeight={700} color={C.textDark}>
                    Preferred Locations
                  </Typography>
                </Box>
                <Box sx={{ pl: 0.5 }}>
                  {locationsList.map((loc, idx) => (
                    <Box
                      key={idx}
                      sx={{ display: "flex", alignItems: "center", gap: 0.6, mb: 0.4 }}
                    >
                      <LocationOnIcon sx={{ fontSize: 13, color: C.brownFaded }} />
                      <Typography fontSize="0.72rem" color={C.textMid}>
                        {loc}
                      </Typography>
                    </Box>
                  ))}
                </Box>
              </Box>
            )}

            {/* Last Active + Posted By row */}
            <Box
              sx={{
                display: "grid",
                gridTemplateColumns: "1fr 1fr",
                gap: 1,
                mb: 2,
                p: 1.2,
                backgroundColor: "#FAF5ED",
                borderRadius: 2,
              }}
            >
              <Box sx={{ display: "flex", alignItems: "center", gap: 0.8 }}>
                <Box
                  sx={{
                    width: 26,
                    height: 26,
                    borderRadius: "50%",
                    backgroundColor: C.tan,
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                  }}
                >
                  <CalendarMonthOutlinedIcon sx={{ fontSize: 15, color: C.brown }} />
                </Box>
                <Box>
                  <Typography fontSize="0.6rem" color={C.textMuted} fontWeight={600}>
                    Last Active On
                  </Typography>
                  <Typography fontSize="0.75rem" fontWeight={700} color={C.textDark}>
                    {formatDate(data.updated_at || data.created_at)}
                  </Typography>
                </Box>
              </Box>

              <Box sx={{ display: "flex", alignItems: "center", gap: 0.8 }}>
                <Box
                  sx={{
                    width: 26,
                    height: 26,
                    borderRadius: "50%",
                    backgroundColor: C.tan,
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                  }}
                >
                  <PersonOutlineIcon sx={{ fontSize: 15, color: C.brown }} />
                </Box>
                <Box>
                  <Typography fontSize="0.6rem" color={C.textMuted} fontWeight={600}>
                    Posted By
                  </Typography>
                  <Typography fontSize="0.75rem" fontWeight={700} color={C.textDark}>
                    {usersMap[data.user_id] || `User ${data.user_id}`}
                  </Typography>
                </Box>
              </Box>
            </Box>

            {/* Comments section */}
            <Box sx={{ mb: 2 }}>
              <Box
                onClick={toggleComments}
                sx={{ display: "flex", alignItems: "center", gap: 0.6, mb: 0.8, cursor: "pointer" }}
              >
                <Box
                  sx={{
                    width: 26,
                    height: 26,
                    borderRadius: "50%",
                    backgroundColor: C.tan,
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                  }}
                >
                  <ChatBubbleOutlineIcon sx={{ fontSize: 14, color: C.brown }} />
                </Box>
                <Typography fontSize="0.78rem" fontWeight={700} color={C.textDark}>
                  Comments
                </Typography>
              </Box>

              {openComments && (
                <Typography fontSize="0.8rem" color={C.textMuted} sx={{ mb: 1.5, pl: 0.5 }}>
                  Post your property related to this requirement and Copy that link and paste here to show User.
                </Typography>
              )}
            </Box>

            {/* URL Input */}
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                gap: 1,
                p: 0.8,
                pl: 1.2,
                border: `1px solid ${C.tanBorder}`,
                borderRadius: "25px",
                backgroundColor: "#FAF5ED",
              }}
            >
              <LinkIcon sx={{ fontSize: 18, color: C.brownFaded }} />
              <TextField
                fullWidth
                variant="standard"
                placeholder="Paste property link"
                value={propertyLink}
                onChange={(e) => setPropertyLink(e.target.value)}
                InputProps={{
                  disableUnderline: true,
                  sx: { fontSize: "0.75rem", color: C.textDark },
                }}
              />
              <Button
                variant="contained"
                size="small"
                onClick={(e) => requireLogin(e, handleSubmitUrl)}
                disabled={submitting || !propertyLink.trim()}
                sx={{
                  fontSize: "0.68rem",
                  fontWeight: 700,
                  minWidth: "auto",
                  px: 2,
                  py: 0.5,
                  backgroundColor: C.brown,
                  color: "#fff",
                  borderRadius: "20px",
                  textTransform: "none",
                  boxShadow: "none",
                  "&:hover": { backgroundColor: C.brownLight, boxShadow: "none" },
                  "&.Mui-disabled": { backgroundColor: "#C9B9A6", color: "#fff" },
                }}
              >
                {submitting ? "..." : "SUBMIT"}
              </Button>
            </Box>
          </Box>
        </Card>

        {/* ═══════════ BOTTOM CARD — PROPERTY RESPONSES ═══════════ */}
        <Card
          sx={{
            borderRadius: 3,
            backgroundColor: C.cardBg,
            boxShadow: "0 2px 10px rgba(107,74,43,0.08)",
          }}
        >
          <Box sx={{ p: 2 }}>
            {/* Header */}
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
                mb: 1.5,
              }}
            >
              <Box sx={{ display: "flex", alignItems: "center", gap: 0.6 }}>
                <PeopleAltIcon sx={{ fontSize: 20, color: C.brown }} />
                <Typography fontSize="0.95rem" fontWeight={700} color={C.textDark}>
                  Property Responses ({responseItems.length})
                </Typography>
              </Box>

              <Box
                onClick={toggleResponses}
                sx={{
                  display: "flex",
                  alignItems: "center",
                  gap: 0.3,
                  cursor: "pointer",
                  color: C.textMuted,
                }}
              >
                <Typography fontSize="0.72rem" fontWeight={600}>
                  {openResponses ? "Hide" : "Show"}
                </Typography>
                {openResponses ? (
                  <KeyboardArrowUpIcon sx={{ fontSize: 16 }} />
                ) : (
                  <KeyboardArrowDownIcon sx={{ fontSize: 16 }} />
                )}
              </Box>
            </Box>

            {/* Responses list */}
            {openResponses && (
              <>
                {responseItems.length === 0 ? (
                  <Typography
                    sx={{
                      fontSize: "0.8rem",
                      color: C.textMuted,
                      textAlign: "center",
                      py: 3,
                    }}
                  >
                    No property responses yet.
                  </Typography>
                ) : (
                  <>
                    {responseItems.slice(0, 2).map((response, index) => (
                      <ResponseCard
                        key={index}
                        response={response}
                        usersMap={usersMap}
                        formatDate={formatDate}
                        navigate={navigate}
                      />
                    ))}

                    {responseItems.length > 2 && (
                      <Box
                        onClick={handleViewAllResponses}
                        sx={{
                          display: "flex",
                          justifyContent: "center",
                          alignItems: "center",
                          gap: 0.3,
                          mt: 1.5,
                          cursor: "pointer",
                        }}
                      >
                        <Typography
                          sx={{
                            fontSize: "0.78rem",
                            fontWeight: 700,
                            color: C.brown,
                            "&:hover": { textDecoration: "underline" },
                          }}
                        >
                          View all {responseItems.length} responses
                        </Typography>
                        <KeyboardArrowRightIcon
                          sx={{ fontSize: 16, color: C.brown }}
                        />
                      </Box>
                    )}
                  </>
                )}
              </>
            )}
          </Box>
        </Card>
      </Box>

      {/* ─────────── Modals ─────────── */}
      <GuestLoginModal
        open={showGuestModal}
        onClose={() => setShowGuestModal(false)}
      />

      {showSuccess && (
        <SuccessAlert
          message={alertMessage}
          onClose={() => {
            setShowSuccess(false);
            setAlertMessage("");
          }}
        />
      )}

      {showFailure && (
        <FailureAlert
          message={alertMessage}
          onClose={() => {
            setShowFailure(false);
            setAlertMessage("");
          }}
        />
      )}

      {/* Bottom Navigation */}
      <Box sx={{ position: "fixed", bottom: 0, left: 0, right: 0, zIndex: 1300 }}>
        <CustomBottomNavbar />
      </Box>
    </Box>
  );
};

// ═══════════════════════════════════════════════════════════════════════════
// Response Card Component
// ═══════════════════════════════════════════════════════════════════════════
const ResponseCard = ({ response, usersMap, formatDate, navigate }) => {
  const [isHovered, setIsHovered] = React.useState(false);
  const userName = usersMap[response.user_id] || `User ${response.user_id}`;
  const userInitial = userName.charAt(0).toUpperCase();

  // derive role from link type or response data (fallback to Property Owner)
  const roleLabel = response.property_by === "Agent" ? "Agent" : "Property Owner";
  const isAgent = roleLabel === "Agent";

  // Extract property ID from link for display
  const extractPropertyId = (link) => {
    if (!link) return null;
    const match = link.match(/\/(\d+)(?:\/)?$/);
    return match ? match[1] : null;
  };
  const propId = extractPropertyId(response.proerty_link);

  // Determine link type from URL
  const getLinkType = (link) => {
    if (!link) return "";
    if (link.includes("buy-description")) return "Purchase";
    if (link.includes("rent-description")) return "Rent";
    if (link.includes("lease-description")) return "Lease";
    return "Property";
  };
  const linkType = getLinkType(response.proerty_link);

  // Format budget if available
  const formatBudgetValue = (num) => {
    const n = parseFloat(num) || 0;
    if (n >= 10000000) return `₹${(n / 10000000).toFixed(1).replace(/\.0$/, "")} Cr`;
    if (n >= 100000) return `₹${(n / 100000).toFixed(1).replace(/\.0$/, "")} L`;
    return `₹${n.toLocaleString("en-IN")}`;
  };

  return (
    <Box
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
      sx={{
        mb: 1.5,
        p: 1.5,
        borderRadius: 2.5,
        backgroundColor: "#FAF5ED",
        border: `1px solid ${C.tanBorder}`,
        transition: "all 0.2s ease",
        "&:hover": {
          boxShadow: "0 2px 8px rgba(107,74,43,0.1)",
        },
      }}
    >
      {/* Top row: Avatar + name/role + tag */}
      <Box
        sx={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "flex-start",
          mb: 1.2,
        }}
      >
        <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
          <Avatar
            sx={{
              width: 34,
              height: 34,
              bgcolor: "#fff",
              color: C.brown,
              border: `1px solid ${C.tanBorder}`,
              fontWeight: 700,
              fontSize: "0.9rem",
            }}
          >
            {userInitial}
          </Avatar>
          <Box>
            <Typography fontSize="0.82rem" fontWeight={700} color={C.textDark}>
              {userName}
            </Typography>
            <Box sx={{ display: "flex", alignItems: "center", gap: 0.3 }}>
              {isAgent ? (
                <StorefrontIcon sx={{ fontSize: 11, color: C.brownFaded }} />
              ) : (
                <HomeWorkOutlinedIcon sx={{ fontSize: 11, color: C.brownFaded }} />
              )}
              <Typography fontSize="0.65rem" color={C.textMuted} fontWeight={500}>
                {roleLabel}
              </Typography>
            </Box>
          </Box>
        </Box>

        {/* Tag */}
        {isAgent ? (
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              gap: 0.4,
              px: 1,
              py: 0.3,
              borderRadius: "20px",
              backgroundColor: "#FFF3E0",
              border: "1px solid #FFE0B2",
            }}
          >
            <StarIcon sx={{ fontSize: 12, color: C.star }} />
            <Typography fontSize="0.65rem" fontWeight={700} color="#8B6914">
              Recommended
            </Typography>
          </Box>
        ) : (
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              gap: 0.4,
              px: 1,
              py: 0.3,
              borderRadius: "20px",
              backgroundColor: C.greenBg,
              border: `1px solid ${C.green}33`,
            }}
          >
            <CheckCircleIcon sx={{ fontSize: 12, color: C.green }} />
            <Typography fontSize="0.65rem" fontWeight={700} color={C.green}>
              Good Match
            </Typography>
          </Box>
        )}
      </Box>

      {/* Location row */}
      <Box sx={{ display: "flex", alignItems: "center", gap: 0.4, mb: 1.2 }}>
        <LocationOnIcon sx={{ fontSize: 13, color: C.brownFaded }} />
        <Typography fontSize="0.7rem" color={C.textMid}>
          {response.location || "Vidyaranyapura, Bengaluru"}
        </Typography>
      </Box>

      {/* Info grid: Plot | Budget | Posted */}
      <Box
        sx={{
          display: "grid",
          gridTemplateColumns: "1.2fr 1fr 1fr",
          gap: 1,
          mb: 1.2,
        }}
      >
        {/* Plot */}
        <Box sx={{ display: "flex", alignItems: "flex-start", gap: 0.5 }}>
          <CropSquareIcon sx={{ fontSize: 14, color: C.brownFaded, mt: 0.2 }} />
          <Box>
            <Typography fontSize="0.6rem" color={C.textMuted} fontWeight={600}>
              Plot
            </Typography>
            <Typography fontSize="0.7rem" fontWeight={700} color={C.textDark}>
              {response.plot_size || "30 x 40 ft"}
            </Typography>
          </Box>
        </Box>

        {/* Budget */}
        <Box sx={{ display: "flex", alignItems: "flex-start", gap: 0.5 }}>
          <CurrencyRupeeIcon sx={{ fontSize: 14, color: C.brownFaded, mt: 0.2 }} />
          <Box>
            <Typography fontSize="0.6rem" color={C.textMuted} fontWeight={600}>
              Budget
            </Typography>
            <Typography fontSize="0.7rem" fontWeight={700} color={C.textDark}>
              {response.price ? formatBudgetValue(response.price) : "₹65,00,000"}
            </Typography>
          </Box>
        </Box>

        {/* Posted */}
        <Box sx={{ display: "flex", alignItems: "flex-start", gap: 0.5 }}>
          <CalendarMonthOutlinedIcon sx={{ fontSize: 14, color: C.brownFaded, mt: 0.2 }} />
          <Box>
            <Typography fontSize="0.6rem" color={C.textMuted} fontWeight={600}>
              Posted
            </Typography>
            <Typography fontSize="0.7rem" fontWeight={700} color={C.textDark}>
              {formatDate(response.created_at)}
            </Typography>
          </Box>
        </Box>
      </Box>

      {/* View Details button */}
      <Box sx={{ display: "flex", justifyContent: "flex-end" }}>
        <Button
          endIcon={<KeyboardArrowRightIcon sx={{ fontSize: 14 }} />}
          onClick={() => {
            if (response.proerty_link) {
              window.open(response.proerty_link, "_blank", "noopener,noreferrer");
            }
          }}
          sx={{
            fontSize: "0.68rem",
            fontWeight: 700,
            textTransform: "none",
            backgroundColor: C.brown,
            color: "#fff",
            borderRadius: "20px",
            px: 1.8,
            py: 0.4,
            minHeight: 26,
            boxShadow: "none",
            "&:hover": { backgroundColor: C.brownLight, boxShadow: "none" },
          }}
        >
          View Details
        </Button>
      </Box>
    </Box>
  );
};

export default WantedPropDetails;